import { render, staticRenderFns } from "./StrengthParamsView.vue?vue&type=template&id=5d8b54a4"
import script from "./StrengthParamsView.vue?vue&type=script&lang=js"
export * from "./StrengthParamsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports